import HttpApi, { HttpApiRequestOptions, HttpApiResult } from './HttpApi';
import BaseResponseDTO from '../models/validation/BaseResponseDTO';
import UpdateUserDTO from '../models/user/UpdateUserDTO';
import UserDTO from '../models/user/UserDTO';
import TableResponseDTO from '../models/datatable/TableResponseDTO';
import UniversalUserSearchDTO from '../models/user/UniversalUserSearchDTO';
import KeyValueDTO from '../models/generic/KeyValueDTO';
import ExcelRowValidationResultDTO from '../models/validation/ExcelRowValidationResultDTO';
import GenericBaseResponseDTO from '../models/validation/GenericBaseResponseDTO';
import UserStatusDTO from '../models/user/UserStatusDTO';
import FullUserStatusDTO from '../models/user/FullUserStatusDTO';
import SimpleUserProgressionDTO from '../models/user/SimpleUserProgressionDTO';
import ValidEmailDTO from '../models/user/ValidEmailDTO';
import AddUserDTO from '../models/user/AddUserDTO';
import TableRequestDTO from '../models/datatable/TableRequestDTO';
import UpdateUserProgressionDTO from '../models/user/UpdateUserProgressionDTO';
import UpdateUserGameDTO from '../models/user/UpdateUserGameDTO';
import VideoWatchedDTO from '../models/user/VideoWatchedDTO';
import ResetPasswordDTO from '../models/account/ResetPasswordDTO';

export class UserApiController {
    // post: User/IsValidEmail
    public RouteIsValidEmail = () => `User/IsValidEmail`;
    public isValidEmail(validEmail: ValidEmailDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<BaseResponseDTO>> {
        let url = this.RouteIsValidEmail();
        return HttpApi.RestRequest<any, BaseResponseDTO>(validEmail, 'post', url, requestOptions);
    }
    // post: User/AddUser
    public RouteAddUser = () => `User/AddUser`;
    public addUser(addUserDTO: AddUserDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<BaseResponseDTO>> {
        let url = this.RouteAddUser();
        return HttpApi.RestRequest<any, BaseResponseDTO>(addUserDTO, 'post', url, requestOptions);
    }
    // post: User/UpdateUser
    public RouteUpdateUser = () => `User/UpdateUser`;
    public updateUser(updateUserDTO: UpdateUserDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<BaseResponseDTO>> {
        let url = this.RouteUpdateUser();
        return HttpApi.RestRequest<any, BaseResponseDTO>(updateUserDTO, 'post', url, requestOptions);
    }
    // get: User/GetUser/${userId}
    public RouteGetUser = (userId: number) => `User/GetUser/${userId}`;
    public getUser(userId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UpdateUserDTO>> {
        let url = this.RouteGetUser(userId);
        return HttpApi.RestRequest<any, UpdateUserDTO>(null, 'get', url, requestOptions);
    }
    // post: User/GetUserTableData/${isAdminTable}/${classroomId}/${onlyClassroomUsers}
    public RouteGetUserTableData = (isAdminTable: boolean, classroomId: number, onlyClassroomUsers: boolean) => `User/GetUserTableData/${isAdminTable}/${classroomId}/${onlyClassroomUsers}`;
    public getUserTableData(tableRequest: TableRequestDTO, isAdminTable: boolean, classroomId: number, onlyClassroomUsers: boolean, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<UserDTO>>> {
        let url = this.RouteGetUserTableData(isAdminTable, classroomId, onlyClassroomUsers);
        return HttpApi.RestRequest<any, TableResponseDTO<UserDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // post: User/GetUserTableData
    public RouteGetUniversalUserSearchTableData = () => `User/GetUserTableData`;
    public getUniversalUserSearchTableData(tableRequest: TableRequestDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<TableResponseDTO<UniversalUserSearchDTO>>> {
        let url = this.RouteGetUniversalUserSearchTableData();
        return HttpApi.RestRequest<any, TableResponseDTO<UniversalUserSearchDTO>>(tableRequest, 'post', url, requestOptions);
    }
    // get: User/GetTeacherCounselorAdminsForSchool
    public RouteGetTeacherCounselorAdminsForSchool = () => `User/GetTeacherCounselorAdminsForSchool`;
    public getTeacherCounselorAdminsForSchool(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetTeacherCounselorAdminsForSchool();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // get: User/AddUserToClassroom/${userId}/${classroomId}
    public RouteAddUserToClassroom = (userId: number, classroomId: number) => `User/AddUserToClassroom/${userId}/${classroomId}`;
    public addUserToClassroom(userId: number, classroomId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<BaseResponseDTO>> {
        let url = this.RouteAddUserToClassroom(userId, classroomId);
        return HttpApi.RestRequest<any, BaseResponseDTO>(null, 'get', url, requestOptions);
    }
    // post: User/DeactivateUser/${userId}
    public RouteDeactivateUser = (userId: number) => `User/DeactivateUser/${userId}`;
    public deactivateUser(userId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteDeactivateUser(userId);
        return HttpApi.RestRequest<any, void>(null, 'post', url, requestOptions);
    }
    // get: User/RemoveUserFromClassroom/${userId}/${classroomId}
    public RouteRemoveUserFromClassroom = (userId: number, classroomId: number) => `User/RemoveUserFromClassroom/${userId}/${classroomId}`;
    public removeUserFromClassroom(userId: number, classroomId: number, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteRemoveUserFromClassroom(userId, classroomId);
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // get: User/GetMassStudentUploadTemplate
    public RouteGetMassStudentUploadTemplate = () => `User/GetMassStudentUploadTemplate`;
    public getMassStudentUploadTemplate(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteGetMassStudentUploadTemplate();
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // get: User/GetAllActiveInactiveStudents/${isActive}
    public RouteGetAllActiveInactiveStudents = (isActive: boolean) => `User/GetAllActiveInactiveStudents/${isActive}`;
    public getAllActiveInactiveStudents(isActive: boolean, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteGetAllActiveInactiveStudents(isActive);
        return HttpApi.RestRequest<any, void>(null, 'get', url, requestOptions);
    }
    // post: User/MassStudentUploadV2
    public RouteMassStudentUploadV2 = () => `User/MassStudentUploadV2`;
    public massStudentUploadV2(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<GenericBaseResponseDTO<ExcelRowValidationResultDTO[]>>> {
        let url = this.RouteMassStudentUploadV2();
        return HttpApi.RestRequest<any, GenericBaseResponseDTO<ExcelRowValidationResultDTO[]>>(null, 'post', url, requestOptions);
    }
    // get: User/GetUserStatus
    public RouteGetUserStatus = () => `User/GetUserStatus`;
    public getUserStatus(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<UserStatusDTO>> {
        let url = this.RouteGetUserStatus();
        return HttpApi.RestRequest<any, UserStatusDTO>(null, 'get', url, requestOptions);
    }
    // get: User/GetFullUserStatus
    public RouteGetFullUserStatus = () => `User/GetFullUserStatus`;
    public getFullUserStatus(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<FullUserStatusDTO>> {
        let url = this.RouteGetFullUserStatus();
        return HttpApi.RestRequest<any, FullUserStatusDTO>(null, 'get', url, requestOptions);
    }
    // post: User/UpdateUserStatus
    public RouteUpdateUserStatus = () => `User/UpdateUserStatus`;
    public updateUserStatus(request: UserStatusDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<FullUserStatusDTO>> {
        let url = this.RouteUpdateUserStatus();
        return HttpApi.RestRequest<any, FullUserStatusDTO>(request, 'post', url, requestOptions);
    }
    // get: User/GetCurrentUserProgression
    public RouteGetCurrentUserProgression = () => `User/GetCurrentUserProgression`;
    public getCurrentUserProgression(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<SimpleUserProgressionDTO>> {
        let url = this.RouteGetCurrentUserProgression();
        return HttpApi.RestRequest<any, SimpleUserProgressionDTO>(null, 'get', url, requestOptions);
    }
    // post: User/UpdateUserProgression
    public RouteUpdateUserProgression = () => `User/UpdateUserProgression`;
    public updateUserProgression(request: UpdateUserProgressionDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<SimpleUserProgressionDTO>> {
        let url = this.RouteUpdateUserProgression();
        return HttpApi.RestRequest<any, SimpleUserProgressionDTO>(request, 'post', url, requestOptions);
    }
    // get: User/GetUserCultures
    public RouteGetUserCultures = () => `User/GetUserCultures`;
    public getUserCultures(requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<KeyValueDTO<number, string>[]>> {
        let url = this.RouteGetUserCultures();
        return HttpApi.RestRequest<any, KeyValueDTO<number, string>[]>(null, 'get', url, requestOptions);
    }
    // post: User/MarkGameCompleted
    public RouteMarkGameCompleted = () => `User/MarkGameCompleted`;
    public markGameCompleted(updateUserGame: UpdateUserGameDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteMarkGameCompleted();
        return HttpApi.RestRequest<any, void>(updateUserGame, 'post', url, requestOptions);
    }
    // post: User/MarkVideoWatched
    public RouteMarkVideoWatched = () => `User/MarkVideoWatched`;
    public markVideoWatched(watched: VideoWatchedDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteMarkVideoWatched();
        return HttpApi.RestRequest<any, void>(watched, 'post', url, requestOptions);
    }
    // post: User/ResetPassword
    public RouteAdminPasswordReset = () => `User/ResetPassword`;
    public adminPasswordReset(resetPassword: ResetPasswordDTO, requestOptions?: HttpApiRequestOptions): Promise<HttpApiResult<void>> {
        let url = this.RouteAdminPasswordReset();
        return HttpApi.RestRequest<any, void>(resetPassword, 'post', url, requestOptions);
    }
}
var service = new UserApiController();
export default service;



// WEBPACK FOOTER //
// ./src/api/UserApiController.ts